import {
  apiRequest,
  PetaJabatanList,
  PetaJabatanExport,
  PetaJabatanExportRekap,
  workUnitList,
  PetaJabatanNewExport,
  PetaJabatanHirarki,
  treeHirarki,
  ListEmployee,
  getInfoUnor,
  getInfoJabatan,
  getInfoResume,
  exportDataNewPetajabatan,
  createInfoJabatan,
  detailInfoJabatan,
  createInfoUnor,
  detailInfoUnor
} from "../../../../../services/adapters/kepegawaian/PetaJabatanService";

class DetailRepository {
  fetchList = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      PetaJabatanList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchExportExcel = async (query) => {
    return await apiRequest(
      "get",
      PetaJabatanExport,
      {
        params: query,
      },
      true
    );
  };

  fetchExportRekap = async (query) => {
    return await apiRequest(
      "get",
      PetaJabatanExportRekap,
      {
        params: query,
      },
      true
    );
  };

  fetchWorkUnit = async (query) => {
    return await apiRequest(
      "get",
      workUnitList,
      {
        params: query,
      },
      true
    );
  };

  fetchExportNew = async (query) => {
    return await apiRequest(
      "get",
      PetaJabatanNewExport,
      {
        params: query,
      },
      true
    );
  };

  fetchListEmployee = async (query) => {
    return await apiRequest(
      "get",
      ListEmployee,
      {
        params: query,
      },
      true
    );
  };

  fetchHirarki = async (query, cancelToken) => {
    return await apiRequest('get', PetaJabatanHirarki, {
        params: query,
        cancelToken: cancelToken
    }, true)
  }

  fetchTreeHirarki = async (query) => {
    return await apiRequest(
      "get",
      treeHirarki,
      {
        params: query,
      },
      true
    );
  };


  fetchInfoUnor = async (query) => {
    return await apiRequest(
      "get",
      getInfoUnor,
      {
        params: query,
      },
      true
    );
  };


  fetchInfoJabatan = async (query) => {
    return await apiRequest(
      "get",
      getInfoJabatan,
      {
        params: query,
      },
      true
    );
  };


  fetchInfoResume = async (query) => {
    return await apiRequest(
      "get",
      getInfoResume,
      {
        params: query,
      },
      true
    );
  };

  fetchexportDataNewPetajabatan = async (query) => {
    return await apiRequest(
      "get",
      exportDataNewPetajabatan,
      {
        params: query,
      },
      true
    );
  };

  fetchdetailInfoJabatan = async (query) => {
    return await apiRequest(
      "get",
      detailInfoJabatan,
      {
        params: query,
      },
      true
    );
  };  

  fetchcreateInfoJabatan = async (query) => {
    return await apiRequest(
      "post",
      createInfoJabatan,
      {
        body: query,
      },
      true
    );
  };

   fetchdetailInfoUnor = async (query) => {
    return await apiRequest(
      "get",
      detailInfoUnor,
      {
        params: query,
      },
      true
    );
  };  

  fetchcreateInfoUnor = async (query) => {
    return await apiRequest(
      "post",
      createInfoUnor,
      {
        body: query,
      },
      true
    );
  };
}

export default DetailRepository;
